export default {
  na: 'N/A',
  loadMore: 'Load More',
  showingResults: 'Showing results from',
  offOn: 'Off/On',
};
